import clsx from "clsx"

export const buttonStyles = disabled =>
  clsx(
    "relative flex items-center justify-center w-12 h-12 bg-white focus:outline-none select-none",
    disabled && "opacity-50 pointer-events-none"
  )

export const scrimStyles =
  "absolute top-0 bottom-0 left-0 right-0 w-full h-full bg-mineralGray opacity-0"

export const iconStyles = "relative"
